import Load from 'components/Load';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import ExperienceFilterSubNavbar from 'modules/common/SubBars/ExperienceFilterSubNavbar';
import React from 'react';
import basePath from 'utils/basePath';

const AsyncSearchResults = Load(
  () =>
    import(
      /* webpackChunkName: "search-page" */ './containers/SearchResultsContainer'
    ),
  {},
  true,
);
const AsyncSearchInput = Load(
  () =>
    import(
      /* webpackChunkName: "search-input-page" */ './containers/SearchInputPage'
    ),
  {},
  true,
);

const SearchRoutes = [
  <NavigationableLayout
    subNavbar={<ExperienceFilterSubNavbar />}
    key="searchresults"
    path={`${basePath}/s/*`}
    component={AsyncSearchResults}
    showSearchInNavbar
    showBottomNavigation
  />,
  <NavigationableLayout
    key="searchinput"
    path={`${basePath}/search/`}
    component={AsyncSearchInput}
    noNavbar
    hideFooter
  />,
];

export default SearchRoutes;
